import cx from 'clsx';
import type { HTMLAttributes, ReactElement } from 'react';
import styles from '../popup.module.css';

export function PopupSubtitle({
  children,
  ...props
}: HTMLAttributes<HTMLHeadElement>): ReactElement {
  return (
    <p className={cx(styles.subtitle, 'body-standard')} data-testid="modal-description" {...props}>
      {children}
    </p>
  );
}
